export const version = '2.4.0';
export const navbarBreakPoint = 'xl';
